import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import type { DownloadAction } from './download-menu.component';

/**
 * The "Download and share" menu sits in the expanded workbook's header, as in the prototype's editor title
 * bar, and the editor below runs what is picked there: the header and the editor are siblings (see
 * `EditorSaveStatus`), so a pick crosses through here. The header shows the menu only while an editor is
 * bound to a workbook, which is when the editor listens.
 */
@Injectable({ providedIn: 'root' })
export class EditorDownloads {
  private readonly picks = new Subject<DownloadAction>();
  public readonly picked = this.picks.asObservable();

  public pick(action: DownloadAction): void {
    this.picks.next(action);
  }
}
